// extracted by mini-css-extract-plugin
module.exports = {"title":"Title-module--title--3q4Ah","titleNowrap":"Title-module--title--nowrap--2x-qa"};